var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fcg-tabela-wrapper", style: { maxHeight: _vm.maxAltura } },
    [
      _vm.semDados
        ? _c("div", { staticClass: "fcg-sem-dados" }, [_vm._v("Nada a exibir")])
        : _c("table", { ref: "tabela", staticClass: "fcg-tabela" }, [
            _c("thead", { ref: "thead" }, [
              _c(
                "tr",
                [
                  _c(
                    "th",
                    {
                      staticClass: "col-label",
                      style: {
                        position: "sticky",
                        top: (_vm.topOffsets[0] || 0) + "px",
                        zIndex: 4,
                      },
                      attrs: { rowspan: _vm.alturaHeader },
                    },
                    [_vm._v("Conta")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.cabecalho.anos, function (grupo) {
                    return _c(
                      "th",
                      {
                        key: "ano-" + grupo.ano,
                        style: {
                          position: "sticky",
                          top: (_vm.topOffsets[0] || 0) + "px",
                          zIndex: 2,
                        },
                        attrs: { colspan: grupo.colspan },
                      },
                      [_vm._v(_vm._s(grupo.ano))]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "col-total-geral",
                      style: {
                        position: "sticky",
                        top: (_vm.topOffsets[0] || 0) + "px",
                        zIndex: 2,
                      },
                      attrs: { rowspan: _vm.alturaHeader },
                    },
                    [_vm._v("Total"), _c("br"), _vm._v("Geral")]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "tr",
                _vm._l(_vm.cabecalho.meses, function (grupo) {
                  return _c(
                    "th",
                    {
                      key: "mes-" + grupo.id,
                      style: {
                        position: "sticky",
                        top: (_vm.topOffsets[1] || 0) + "px",
                        zIndex: 2,
                      },
                      attrs: { colspan: grupo.colspan },
                    },
                    [_vm._v(_vm._s(grupo.nome))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "tr",
                _vm._l(_vm.cabecalho.dias, function (dia) {
                  return _c(
                    "th",
                    {
                      key: "dia-" + dia.id,
                      style: {
                        position: "sticky",
                        top: (_vm.topOffsets[2] || 0) + "px",
                        zIndex: 2,
                      },
                      attrs: { colspan: _vm.tiposPorDia(dia.dataKey).length },
                    },
                    [_vm._v(_vm._s(dia.label))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.previstoRealizado
                ? _c(
                    "tr",
                    { staticClass: "fcg-row-tipos" },
                    [
                      _vm._l(_vm.cabecalho.dias, function (dia) {
                        return _vm._l(
                          _vm.tiposPorDia(dia.dataKey),
                          function (tipo) {
                            return _c(
                              "th",
                              {
                                key: "tipo-" + dia.id + "-" + tipo,
                                style: {
                                  position: "sticky",
                                  top: (_vm.topOffsets[3] || 0) + "px",
                                  zIndex: 2,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(tipo === "Delta" ? "Δ" : tipo) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _c(
                  "tr",
                  {
                    staticClass: "fcg-section-header",
                    on: {
                      click: function ($event) {
                        return _vm.toggleSecao("saldoInicial")
                      },
                    },
                  },
                  [
                    _c("td", { attrs: { colspan: _vm.totalColunas } }, [
                      _c("span", { staticClass: "fcg-expand-toggle" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.secoesAbertas.saldoInicial ? "▼" : "▶") +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(
                        "\n                    Saldo Inicial\n                "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.secoesAbertas.saldoInicial &&
                _vm.saldoInicialData &&
                _vm.agrupaPorTipoConta
                  ? [
                      _vm._l(
                        _vm.contasAgrupadasPorTipo(_vm.saldoInicialData),
                        function (grupo) {
                          return [
                            _c(
                              "tr",
                              {
                                key: "si-gh-" + grupo.idTipoConta,
                                staticClass: "fcg-group-header",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleGrupo(
                                      "si",
                                      grupo.idTipoConta
                                    )
                                  },
                                },
                              },
                              [
                                _c("td", { staticClass: "col-label" }, [
                                  _c(
                                    "span",
                                    { staticClass: "fcg-expand-toggle" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.grupoAberto(
                                              "si",
                                              grupo.idTipoConta
                                            )
                                              ? "▼"
                                              : "▶"
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(grupo.tipoConta) +
                                      "\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.cabecalho.dias, function (dia) {
                                  return _vm._l(
                                    _vm.tiposPorDia(dia.dataKey),
                                    function (tipo) {
                                      return _c(
                                        "td",
                                        {
                                          key:
                                            "si-gh-" +
                                            grupo.idTipoConta +
                                            "-" +
                                            dia.id +
                                            "-" +
                                            tipo,
                                          class: _vm.classeCor(
                                            _vm.totalSaldoPorGrupoDia(
                                              _vm.saldoInicialData,
                                              grupo.contas,
                                              dia.dataKey,
                                              tipo
                                            )
                                          ),
                                          attrs: {
                                            "data-val":
                                              _vm.totalSaldoPorGrupoDia(
                                                _vm.saldoInicialData,
                                                grupo.contas,
                                                dia.dataKey,
                                                tipo
                                              ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.formatBRL(
                                                  _vm.totalSaldoPorGrupoDia(
                                                    _vm.saldoInicialData,
                                                    grupo.contas,
                                                    dia.dataKey,
                                                    tipo
                                                  )
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: _vm.classeCor(
                                      _vm.totalGeralPorGrupoSaldo(
                                        _vm.saldoInicialData,
                                        grupo.contas
                                      )
                                    ),
                                    attrs: {
                                      "data-val": _vm.totalGeralPorGrupoSaldo(
                                        _vm.saldoInicialData,
                                        grupo.contas
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formatBRL(
                                            _vm.totalGeralPorGrupoSaldo(
                                              _vm.saldoInicialData,
                                              grupo.contas
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.grupoAberto("si", grupo.idTipoConta)
                              ? _vm._l(grupo.contas, function (conta) {
                                  return _c(
                                    "tr",
                                    { key: "si-" + conta.handle },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "col-label",
                                          attrs: { title: conta.nome },
                                        },
                                        [_vm._v(_vm._s(conta.nome))]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.cabecalho.dias,
                                        function (dia) {
                                          return _vm._l(
                                            _vm.tiposPorDia(dia.dataKey),
                                            function (tipo) {
                                              return _c(
                                                "td",
                                                {
                                                  key:
                                                    "si-c-" +
                                                    conta.handle +
                                                    "-" +
                                                    dia.id +
                                                    "-" +
                                                    tipo,
                                                  class: _vm.classeCor(
                                                    _vm.getValorSaldo(
                                                      _vm.saldoInicialData,
                                                      conta.handle,
                                                      dia.dataKey,
                                                      tipo
                                                    )
                                                  ),
                                                  attrs: {
                                                    "data-val":
                                                      _vm.getValorSaldo(
                                                        _vm.saldoInicialData,
                                                        conta.handle,
                                                        dia.dataKey,
                                                        tipo
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.formatBRL(
                                                          _vm.getValorSaldo(
                                                            _vm.saldoInicialData,
                                                            conta.handle,
                                                            dia.dataKey,
                                                            tipo
                                                          )
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.classeCor(
                                            _vm.totalGeralPorContaSaldo(
                                              _vm.saldoInicialData,
                                              conta.handle
                                            )
                                          ),
                                          attrs: {
                                            "data-val":
                                              _vm.totalGeralPorContaSaldo(
                                                _vm.saldoInicialData,
                                                conta.handle
                                              ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.formatBRL(
                                                  _vm.totalGeralPorContaSaldo(
                                                    _vm.saldoInicialData,
                                                    conta.handle
                                                  )
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  )
                                })
                              : _vm._e(),
                          ]
                        }
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.secoesAbertas.saldoInicial &&
                _vm.saldoInicialData &&
                !_vm.agrupaPorTipoConta
                  ? _vm._l(
                      _vm.contasOrdenadasFlat(_vm.saldoInicialData),
                      function (conta) {
                        return _c(
                          "tr",
                          { key: "si-flat-" + conta.handle },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "col-label",
                                attrs: { title: conta.nome },
                              },
                              [_vm._v(_vm._s(conta.nome))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.cabecalho.dias, function (dia) {
                              return _vm._l(
                                _vm.tiposPorDia(dia.dataKey),
                                function (tipo) {
                                  return _c(
                                    "td",
                                    {
                                      key:
                                        "si-flat-c-" +
                                        conta.handle +
                                        "-" +
                                        dia.id +
                                        "-" +
                                        tipo,
                                      class: _vm.classeCor(
                                        _vm.getValorSaldo(
                                          _vm.saldoInicialData,
                                          conta.handle,
                                          dia.dataKey,
                                          tipo
                                        )
                                      ),
                                      attrs: {
                                        "data-val": _vm.getValorSaldo(
                                          _vm.saldoInicialData,
                                          conta.handle,
                                          dia.dataKey,
                                          tipo
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.formatBRL(
                                              _vm.getValorSaldo(
                                                _vm.saldoInicialData,
                                                conta.handle,
                                                dia.dataKey,
                                                tipo
                                              )
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                class: _vm.classeCor(
                                  _vm.totalGeralPorContaSaldo(
                                    _vm.saldoInicialData,
                                    conta.handle
                                  )
                                ),
                                attrs: {
                                  "data-val": _vm.totalGeralPorContaSaldo(
                                    _vm.saldoInicialData,
                                    conta.handle
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.formatBRL(
                                        _vm.totalGeralPorContaSaldo(
                                          _vm.saldoInicialData,
                                          conta.handle
                                        )
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          2
                        )
                      }
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "tr",
                  { staticClass: "fcg-section-total" },
                  [
                    _c("td", { staticClass: "col-label" }, [
                      _vm._v("Total Saldo Inicial"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.cabecalho.dias, function (dia) {
                      return _vm._l(
                        _vm.tiposPorDia(dia.dataKey),
                        function (tipo) {
                          return _c(
                            "td",
                            {
                              key: "si-t-" + dia.id + "-" + tipo,
                              class: _vm.classeCor(
                                _vm.totalSaldoPorDia(
                                  _vm.saldoInicialData,
                                  dia.dataKey,
                                  tipo
                                )
                              ),
                              attrs: {
                                "data-val": _vm.totalSaldoPorDia(
                                  _vm.saldoInicialData,
                                  dia.dataKey,
                                  tipo
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.formatBRL(
                                      _vm.totalSaldoPorDia(
                                        _vm.saldoInicialData,
                                        dia.dataKey,
                                        tipo
                                      )
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        class: _vm.classeCor(
                          _vm.totalGeralSecao("saldoInicial")
                        ),
                        attrs: {
                          "data-val": _vm.totalGeralSecao("saldoInicial"),
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.formatBRL(_vm.totalGeralSecao("saldoInicial"))
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    staticClass: "fcg-section-header",
                    on: {
                      click: function ($event) {
                        return _vm.toggleSecao("movimentacoes")
                      },
                    },
                  },
                  [
                    _c("td", { attrs: { colspan: _vm.totalColunas } }, [
                      _c("span", { staticClass: "fcg-expand-toggle" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.secoesAbertas.movimentacoes ? "▼" : "▶"
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(
                        "\n                    Movimentações\n                "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.secoesAbertas.movimentacoes
                  ? _vm._l(_vm.linhasMovimentacoesVisiveis, function (linha) {
                      return _c(
                        "tr",
                        {
                          key: "mov-" + linha.path,
                          class: { "fcg-row-clickable": linha.temFilhos },
                          on: {
                            click: function ($event) {
                              return _vm.onLinhaClickGeral(linha)
                            },
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "col-label",
                              style: {
                                paddingLeft: 12 + linha.nivel * 12 + "px",
                              },
                              attrs: { title: linha.label },
                            },
                            [
                              linha.temFilhos
                                ? _c(
                                    "span",
                                    { staticClass: "fcg-expand-toggle" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.noExpandido(linha.path)
                                              ? "▼"
                                              : "▶"
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "fcg-expand-spacer",
                                  }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(linha.label) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.cabecalho.dias, function (dia) {
                            return _vm._l(
                              _vm.tiposPorDia(dia.dataKey),
                              function (tipo) {
                                return _c(
                                  "td",
                                  {
                                    key:
                                      "mov-c-" +
                                      linha.path +
                                      "-" +
                                      dia.id +
                                      "-" +
                                      tipo,
                                    class: _vm.classeCor(
                                      _vm.getValorNo(linha, dia.dataKey, tipo)
                                    ),
                                    attrs: {
                                      "data-val": _vm.getValorNo(
                                        linha,
                                        dia.dataKey,
                                        tipo
                                      ),
                                      title:
                                        "Clique duas vezes na célula para visualizar o analítico",
                                    },
                                    on: {
                                      dblclick: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.onCelulaClique(
                                          linha,
                                          dia,
                                          tipo
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formatBRL(
                                            _vm.getValorNo(
                                              linha,
                                              dia.dataKey,
                                              tipo
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: _vm.classeCor(_vm.totalGeralNo(linha)),
                              attrs: { "data-val": _vm.totalGeralNo(linha) },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.formatBRL(_vm.totalGeralNo(linha))
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        2
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    staticClass: "fcg-section-header",
                    on: {
                      click: function ($event) {
                        return _vm.toggleSecao("saldoFinal")
                      },
                    },
                  },
                  [
                    _c("td", { attrs: { colspan: _vm.totalColunas } }, [
                      _c("span", { staticClass: "fcg-expand-toggle" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.secoesAbertas.saldoFinal ? "▼" : "▶") +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(
                        "\n                    Saldo Final\n                "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.secoesAbertas.saldoFinal &&
                _vm.saldoFinalData &&
                _vm.agrupaPorTipoConta
                  ? [
                      _vm._l(
                        _vm.contasAgrupadasPorTipo(_vm.saldoFinalData),
                        function (grupo) {
                          return [
                            _c(
                              "tr",
                              {
                                key: "sf-gh-" + grupo.idTipoConta,
                                staticClass: "fcg-group-header",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleGrupo(
                                      "sf",
                                      grupo.idTipoConta
                                    )
                                  },
                                },
                              },
                              [
                                _c("td", { staticClass: "col-label" }, [
                                  _c(
                                    "span",
                                    { staticClass: "fcg-expand-toggle" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.grupoAberto(
                                              "sf",
                                              grupo.idTipoConta
                                            )
                                              ? "▼"
                                              : "▶"
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(grupo.tipoConta) +
                                      "\n                        "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.cabecalho.dias, function (dia) {
                                  return _vm._l(
                                    _vm.tiposPorDia(dia.dataKey),
                                    function (tipo) {
                                      return _c(
                                        "td",
                                        {
                                          key:
                                            "sf-gh-" +
                                            grupo.idTipoConta +
                                            "-" +
                                            dia.id +
                                            "-" +
                                            tipo,
                                          class: _vm.classeCor(
                                            _vm.totalSaldoPorGrupoDia(
                                              _vm.saldoFinalData,
                                              grupo.contas,
                                              dia.dataKey,
                                              tipo
                                            )
                                          ),
                                          attrs: {
                                            "data-val":
                                              _vm.totalSaldoPorGrupoDia(
                                                _vm.saldoFinalData,
                                                grupo.contas,
                                                dia.dataKey,
                                                tipo
                                              ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.formatBRL(
                                                  _vm.totalSaldoPorGrupoDia(
                                                    _vm.saldoFinalData,
                                                    grupo.contas,
                                                    dia.dataKey,
                                                    tipo
                                                  )
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: _vm.classeCor(
                                      _vm.totalGeralPorGrupoSaldo(
                                        _vm.saldoFinalData,
                                        grupo.contas
                                      )
                                    ),
                                    attrs: {
                                      "data-val": _vm.totalGeralPorGrupoSaldo(
                                        _vm.saldoFinalData,
                                        grupo.contas
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formatBRL(
                                            _vm.totalGeralPorGrupoSaldo(
                                              _vm.saldoFinalData,
                                              grupo.contas
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.grupoAberto("sf", grupo.idTipoConta)
                              ? _vm._l(grupo.contas, function (conta) {
                                  return _c(
                                    "tr",
                                    { key: "sf-" + conta.handle },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "col-label",
                                          attrs: { title: conta.nome },
                                        },
                                        [_vm._v(_vm._s(conta.nome))]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.cabecalho.dias,
                                        function (dia) {
                                          return _vm._l(
                                            _vm.tiposPorDia(dia.dataKey),
                                            function (tipo) {
                                              return _c(
                                                "td",
                                                {
                                                  key:
                                                    "sf-c-" +
                                                    conta.handle +
                                                    "-" +
                                                    dia.id +
                                                    "-" +
                                                    tipo,
                                                  class: _vm.classeCor(
                                                    _vm.getValorSaldo(
                                                      _vm.saldoFinalData,
                                                      conta.handle,
                                                      dia.dataKey,
                                                      tipo
                                                    )
                                                  ),
                                                  attrs: {
                                                    "data-val":
                                                      _vm.getValorSaldo(
                                                        _vm.saldoFinalData,
                                                        conta.handle,
                                                        dia.dataKey,
                                                        tipo
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.formatBRL(
                                                          _vm.getValorSaldo(
                                                            _vm.saldoFinalData,
                                                            conta.handle,
                                                            dia.dataKey,
                                                            tipo
                                                          )
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          class: _vm.classeCor(
                                            _vm.totalGeralPorContaSaldo(
                                              _vm.saldoFinalData,
                                              conta.handle
                                            )
                                          ),
                                          attrs: {
                                            "data-val":
                                              _vm.totalGeralPorContaSaldo(
                                                _vm.saldoFinalData,
                                                conta.handle
                                              ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.formatBRL(
                                                  _vm.totalGeralPorContaSaldo(
                                                    _vm.saldoFinalData,
                                                    conta.handle
                                                  )
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  )
                                })
                              : _vm._e(),
                          ]
                        }
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.secoesAbertas.saldoFinal &&
                _vm.saldoFinalData &&
                !_vm.agrupaPorTipoConta
                  ? _vm._l(
                      _vm.contasOrdenadasFlat(_vm.saldoFinalData),
                      function (conta) {
                        return _c(
                          "tr",
                          { key: "sf-flat-" + conta.handle },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "col-label",
                                attrs: { title: conta.nome },
                              },
                              [_vm._v(_vm._s(conta.nome))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.cabecalho.dias, function (dia) {
                              return _vm._l(
                                _vm.tiposPorDia(dia.dataKey),
                                function (tipo) {
                                  return _c(
                                    "td",
                                    {
                                      key:
                                        "sf-flat-c-" +
                                        conta.handle +
                                        "-" +
                                        dia.id +
                                        "-" +
                                        tipo,
                                      class: _vm.classeCor(
                                        _vm.getValorSaldo(
                                          _vm.saldoFinalData,
                                          conta.handle,
                                          dia.dataKey,
                                          tipo
                                        )
                                      ),
                                      attrs: {
                                        "data-val": _vm.getValorSaldo(
                                          _vm.saldoFinalData,
                                          conta.handle,
                                          dia.dataKey,
                                          tipo
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.formatBRL(
                                              _vm.getValorSaldo(
                                                _vm.saldoFinalData,
                                                conta.handle,
                                                dia.dataKey,
                                                tipo
                                              )
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                class: _vm.classeCor(
                                  _vm.totalGeralPorContaSaldo(
                                    _vm.saldoFinalData,
                                    conta.handle
                                  )
                                ),
                                attrs: {
                                  "data-val": _vm.totalGeralPorContaSaldo(
                                    _vm.saldoFinalData,
                                    conta.handle
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.formatBRL(
                                        _vm.totalGeralPorContaSaldo(
                                          _vm.saldoFinalData,
                                          conta.handle
                                        )
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          2
                        )
                      }
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "tr",
                  { staticClass: "fcg-section-total" },
                  [
                    _c("td", { staticClass: "col-label" }, [
                      _vm._v("Total Saldo Final"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.cabecalho.dias, function (dia) {
                      return _vm._l(
                        _vm.tiposPorDia(dia.dataKey),
                        function (tipo) {
                          return _c(
                            "td",
                            {
                              key: "sf-t-" + dia.id + "-" + tipo,
                              class: _vm.classeCor(
                                _vm.totalSaldoPorDia(
                                  _vm.saldoFinalData,
                                  dia.dataKey,
                                  tipo
                                )
                              ),
                              attrs: {
                                "data-val": _vm.totalSaldoPorDia(
                                  _vm.saldoFinalData,
                                  dia.dataKey,
                                  tipo
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.formatBRL(
                                      _vm.totalSaldoPorDia(
                                        _vm.saldoFinalData,
                                        dia.dataKey,
                                        tipo
                                      )
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        class: _vm.classeCor(_vm.totalGeralSecao("saldoFinal")),
                        attrs: {
                          "data-val": _vm.totalGeralSecao("saldoFinal"),
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.formatBRL(_vm.totalGeralSecao("saldoFinal"))
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              2
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }